import { HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@core/services/login.service';
import { environment } from 'environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login-token',
  templateUrl: './login-token.component.html',
  styleUrls: ['./login-token.component.scss'],
})
export class LoginTokenComponent implements OnInit, OnDestroy {

  token = '';

  user: any;
  dashboardRoute = '';

  loading = false;

  routes = environment.routes

  $subs: Subscription[] = [];

  constructor(private route: ActivatedRoute, private loginService: LoginService, private router: Router) {}

  ngOnInit(): void {
    const lang = this.route.snapshot.paramMap.get('lang');
    if(!!lang) localStorage.setItem('language', lang);
    else localStorage.setItem('language', 'en');

    const sub = this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      if (this.token) this.loginToken();
      else this.router.navigate(['/']);
    });
    this.$subs.push(sub);
  }

  loginToken(): void {
    // const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
      .append('Authorization', `Bearer ${this.token}`);
    this.loginService.loginToken({token: this.token}, headers).subscribe((res) => {
      this.setLocalStorage(res?.Object);
      this.loginService.getScoresLogin(res?.Object?.token?.token).subscribe((response) => {
        var scores = response.Object;
        var score = {
          'xp': scores.xp,
          'coins': scores.coins
        };
        localStorage.setItem('score', JSON.stringify(score));
      }, err => {
        this.redirect(res?.Object, 0);
      });
      // var cookie = this.getCookie('robogarden_user');
      // if (cookie) {
        this.redirect(res?.Object, 0);
      // }
    }, err => {
      this.router.navigate(['/']);
    });
  }

  redirect(result: any, isCompetitionStudent: number) {
    if(localStorage.getItem('redirectProfilePlans')) //OR (window.location.href.includes('leaderboard'))
    {
        localStorage.removeItem('redirectProfilePlans');
        localStorage.setItem('openProfilePlans', 'true');
        window.location.replace(this.routes.ProfilePlans);


    }
    else if(this.user?.role == 'school_admin')
    {
        //if(RobogardenServices.getPlan()) //FIXME not implemented
        //window.location.replace(this.routes.dashboard);
        //else
        // window.location.replace(this.routes.dashboard);

        if (localStorage.getItem('school_redirect_plans')) //from school plans
        {
            localStorage.removeItem('school_redirect_plans');
            window.location.replace(this.routes.paymentdetails);
        } else {
            window.location.replace(this.routes.dashboard);
        }
    } else if (this.user?.role == 'teacher')
        window.location.replace(this.routes.TeacherDashboard);
    else if (this.user?.role == 'student')
        window.location.replace(this.routes.studenthomepage);
    else if (this.user?.isCompetitionStudent && isCompetitionStudent)
        window.location.replace(this.routes.learn2codePrograms);
    else if (localStorage.getItem('worldUser')) //OR (window.location.href.includes('leaderboard'))
    {
        localStorage.removeItem('worldUser');
        window.location.replace(this.routes.index_worldCup);
    } else if (localStorage.getItem('homescholer_registered')) //from school plans
    {
        localStorage.removeItem('homescholer_registered');
        window.location.replace(this.routes.index_parent);
    } else if (localStorage.getItem('learner_registered')) //from school plans
    {
        localStorage.removeItem('learner_registered');
        window.location.replace(this.routes.index_individual);
    }else if (('redirectToJourney' in result) && ('redirectToJourneyId' in result) &&
     result.redirectToJourney){

        window.location.replace(this.routes.individual_journey+result.redirectToJourneyId);
    }
    else {
        //if(RobogardenServices.getPlan()) //FIXME not implemented
        //window.location.replace(this.routes.payment + '/' + result.account_type);
        //else
        window.location.replace(this.routes.index_journeys);
    }
  }

  setLocalStorage(result: any) {
    if (result?.user) {
      const authorizationData = {
        'username': result.user?.username,
        'email': result.user?.email,
        'fname': result.user?.first_name,
        'lname': result.user?.last_name,
        'id': result.user?.id,
        'image_link': result.user?.profile_image_url,
        'logged_in': true,
        'social_id': result.user?.social_id,
        'social_track': result.user?.social_track,
        'role': result.user?.role,
        'roles': result.user?.roles,
        'hasAdminLoginAs': result.user?.hasAdminLoginAs,
        'trialEnd': result.trialEnd,
        'country': result.user?.account?.country,
        'robopal': result.RoboPalAuth ? result.RoboPalAuth.permission : '',
        'robopal_end': result.RoboPalAuth ? result.RoboPalAuth.end_date : '',
        'robopal_cancelled': result.RoboPalAuth ? result.RoboPalAuth.cancelled : '',
        'status': result.status ? result.status : result.user?.account?.status ? result.user?.account.status : result.account?.status,
        'account_type': result.account_type,
        'invited': result.invited,
        'is_admin': result.user?.is_admin,
        'isCompetitionStudent': result.user?.isCompetitionStudent,
        'CompetitionStudentGrade': result.user?.CompetitionStudentGrade,
        'CompetitionCountry': result.user?.CompetitionCountry,
        'isOrangeServiceUser': result.user?.isOrangeServiceUser,
        'currentJourneyId': result.user?.user_position?.JourneyId,
        'is_ceibal_user': result.user?.is_ceibal_user,
        "inCeibalOlympiad":result.user?.inCeibalOlympiad,
        'features': result.features,
        is_eupheusschoolos_user:result.user?.is_eupheusschoolos_user
      };
      if(result.user?.is_ceibal_user){
        // window.location.href='/set-locale/es'
        localStorage.setItem('language','es')
      }
      localStorage.setItem('satellizer_token', result.token.token);
      localStorage.setItem('AuthorizationData', JSON.stringify(authorizationData));
      localStorage.setItem('stripe_user', result.use_stripe);
      this.checkUserData();
    }
  }

  checkUserData(): void {
    const user = localStorage.getItem('AuthorizationData');
    if (user) this.user = JSON.parse(user);
    else this.user = null;
    this.getDashboardRoute();
  }

  getDashboardRoute(): void {
    if (this.user?.is_admin) {
      this.dashboardRoute = '/index/journeys';
    } else if (this.user?.role === 'school_admin') {
      this.dashboardRoute = '/index/school/dashboard';
    } else if (this.user?.role === 'teacher') {
      this.dashboardRoute = '/index/teacher/dashboard';
    } else if (this.user?.role === 'student') {
      this.dashboardRoute = '/index/student/home';
    } else {
      this.dashboardRoute = '/index/journeys';
    }
  }

  getCookie(name: string) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    var end = null;
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
        end = document.cookie.indexOf(";", begin);
    } else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);
        if (end == -1) {
            end = dc.length;
        }
    }
    return decodeURI(dc.substring(begin + prefix.length, end)).replace(/"/g, '');
  }

  ngOnDestroy(): void {
    this.$subs.forEach(sub => sub.unsubscribe());
  }

}
